import FlashIcon from "./icon-flash.component.svg";
export default FlashIcon;
//# sourceMappingURL=index.js.map